import { render } from "./FpuiInputText.vue?vue&type=template&id=06e4fe9a"
import script from "./FpuiInputText.vue?vue&type=script&lang=js"
export * from "./FpuiInputText.vue?vue&type=script&lang=js"

import "./FpuiInputText.vue?vue&type=style&index=0&id=06e4fe9a&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__